module.exports = __webpack_public_path__ + "static/img/yezj.23efb482.png";